import React, { useEffect } from 'react';
import mixpanel from 'mixpanel-browser';
import { UserProfileSettings } from '@/components/UserProfileSettings';
import { ProfileAvailabilitySection } from '@/components/ProfileAvailabilitySection';
import { User } from 'lucide-react';

export default function Profile() {
  useEffect(() => { mixpanel.track('app_profile_view') }, [])
  return (
    <div className="w-full space-y-6">
      {/* Header */}
      <div className="flex items-center gap-3">
        <div className="p-2 bg-primary/10 rounded-lg w-fit">
          <User className="h-6 w-6 sm:h-8 sm:w-8 text-primary" />
        </div>
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold tracking-tight">Minha Conta</h1>
          <p className="text-sm sm:text-base text-muted-foreground mt-1">
            Gerencie suas informações pessoais e de contato
          </p>
        </div>
      </div>

      {/* Perfil do Usuário */}
      <UserProfileSettings />

      {/* Disponibilidade para agendamento */}
      <ProfileAvailabilitySection />
    </div>
  );
}
